import { useCallback, useEffect, useState } from "react";
import { http } from "../../lib/api";
import { Btn, Card } from "../kit/Kit";
import { CAT, Res, Vacio } from "./common";
import { Detalle } from "./Detalle";
import { Filtros, Paquete, params } from "./Filtros";

export const Fila = ({ e, onClick }) => (
  <button onClick={onClick} className="grid w-full grid-cols-[1fr_auto] gap-x-3 gap-y-0.5 border-t border-[#F2F0EC] px-1 py-2.5 text-left transition-colors hover:bg-[#FAF8F5] md:grid-cols-[150px_180px_1fr_120px_auto]" data-testid="bit-row">
    <span className="font-mono text-[11px] text-[#5C5850]">{e.ts_mx}</span>
    <span className="justify-self-end md:order-last"><Res r={e.resultado} /></span>
    <span className="truncate text-sm font-medium">{e.actor || "—"}{e.qa && <span className="ml-1 rounded bg-sky-100 px-1 text-[10px] text-sky-800">QA</span>}</span>
    <span className="col-span-2 truncate text-xs text-[#5C5850] md:col-span-1">{CAT[e.categoria] || e.categoria} · {e.modulo} · <b className="text-[#111]">{e.estado === "eliminado" ? "(eliminado)" : e.accion}</b>{e.estado === "corregido" && " · corregido"}</span>
    <span className="col-span-2 truncate font-mono text-[11px] text-[#8C867A] md:col-span-1">{e.ip || ""}</span>
  </button>
);

export const Eventos = ({ fijo, usuarios, esMaster, tab }) => {
  const [f, setF] = useState({ actor: "", desde: "", hasta: "", modulo: "", categoria: "", resultado: "", ip: "", qa: false });
  const [d, setD] = useState({ total: 0, items: [] });
  const [lim, setLim] = useState(100);
  const [sel, setSel] = useState(null);
  const p = params(f, fijo);
  const key = JSON.stringify(p);
  const load = useCallback(() => http.get("/audit/eventos", { params: { ...JSON.parse(key), limit: lim } }).then((r) => setD(r.data)).catch(() => setD({ total: 0, items: [] })), [key, lim]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);
  const abrir = (e) => http.get(`/audit/eventos/${e.seq}`).then((r) => setSel(r.data));
  return (
    <div className="space-y-4" data-testid={`bit-eventos-${tab}`}>
      <Card title="Filtros" right={<Paquete p={p} />}><Filtros f={f} setF={setF} fijo={fijo} usuarios={usuarios} /></Card>
      <Card title={`${d.total.toLocaleString("es-MX")} registros`} subtitle={f.qa ? "Incluye eventos QA (pruebas)" : "Eventos QA ocultos"} testid="bit-tabla">
        {d.items.length ? d.items.map((e) => <Fila key={e.seq} e={e} onClick={() => abrir(e)} />) : <Vacio testid="bit-vacio" />}
        {d.total > d.items.length && <div className="pt-3 text-center"><Btn kind="secondary" onClick={() => setLim(lim + 200)} data-testid="bit-mas">Ver más</Btn></div>}
      </Card>
      <Detalle e={sel} onClose={() => setSel(null)} esMaster={esMaster} onDone={() => { abrir(sel); load(); }} />
    </div>
  );
};
